export default "__VITE_ASSET__BlNllakY__"